import { useEffect, useRef } from "preact/hooks";
import { pushEscapeHandler } from "../../state/route";

/** Run `handler` when Escape is pressed while this component is mounted (newest handler wins). */
export function useEscape(handler: () => void, active = true): void {
  const latest = useRef(handler);
  latest.current = handler;
  useEffect(() => {
    if (!active) return;
    return pushEscapeHandler(() => latest.current());
  }, [active]);
}

/** Call `fn` every `ms` milliseconds; pass null to pause. Always calls the latest `fn`. */
export function useInterval(fn: () => void, ms: number | null): void {
  const latest = useRef(fn);
  latest.current = fn;
  useEffect(() => {
    if (ms === null) return;
    const id = window.setInterval(() => latest.current(), ms);
    return () => window.clearInterval(id);
  }, [ms]);
}
